import { render } from "./TablaPagosRegistros.vue?vue&type=template&id=4265d4b9&scoped=true"
import script from "./TablaPagosRegistros.vue?vue&type=script&lang=js"
export * from "./TablaPagosRegistros.vue?vue&type=script&lang=js"

import "./TablaPagosRegistros.vue?vue&type=style&index=0&id=4265d4b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4265d4b9"]])

export default __exports__